import { _pickDevice } from 'console/redux/devices/selected-id';
import { removeDuplicatesFromEventBatches } from './utils';
const device_initial_state = {
    loading: false,
    loaded: false,
    error: null,
    batches: [],
    have_more: false,
};
const initial = {};
export function reducer(state = initial, action) {
    if (_pickDevice.match(action)) {
        if (action.payload && state[action.payload] !== null) {
            return {
                [action.payload]: {
                    loading: false,
                    loaded: false,
                    error: null,
                    batches: [],
                    have_more: false,
                },
            };
        }
    }
    switch (action.type) {
        case 'SET_PERIOD_ACTION':
            return initial;
        case 'LOAD_EVENTS__REQUEST':
            return {
                ...state,
                [action.device_id]: {
                    ...device_initial_state,
                    batches: [],
                    loading: true,
                },
            };
        case 'LOAD_EVENTS__OK':
            return {
                ...state,
                [action.device_id]: {
                    loading: false,
                    loaded: true,
                    error: null,
                    batches: [
                        {
                            id: 0,
                            localizedEvents: action.events,
                        },
                    ],
                    have_more: action.have_more,
                },
            };
        case 'LOAD_EVENTS__FAIL':
            return {
                ...state,
                [action.device_id]: {
                    ...state[action.device_id],
                    loading: false,
                    loaded: false,
                    error: action.error,
                    batches: [],
                    have_more: false,
                },
            };
        case 'LOAD_MORE_EVENTS__REQUEST':
            return {
                ...state,
                [action.device_id]: {
                    ...state[action.device_id],
                    loading: true,
                },
            };
        case 'LOAD_MORE_EVENTS__OK':
            return {
                ...state,
                [action.device_id]: {
                    ...state[action.device_id],
                    loading: false,
                    batches: [
                        ...state[action.device_id].batches,
                        {
                            id: state[action.device_id].batches[state[action.device_id].batches.length - 1].id + 1,
                            localizedEvents: removeDuplicatesFromEventBatches(state[action.device_id].batches[state[action.device_id].batches.length - 1].localizedEvents, action.events),
                        },
                    ],
                    have_more: action.have_more,
                },
            };
        case 'LOAD_MORE_EVENTS__FAIL':
            return {
                ...state,
                [action.device_id]: {
                    ...state[action.device_id],
                    error: action.error,
                },
            };
        case 'APPLY_NEW_EVENT':
            if (state[action.device_id] != null) {
                if (state[action.device_id].batches.length == 0) {
                    return {
                        ...state,
                        [action.device_id]: {
                            ...state[action.device_id],
                            batches: [
                                {
                                    id: 0,
                                    localizedEvents: [action.event],
                                },
                                ...state[action.device_id].batches,
                            ],
                        },
                    };
                }
                return {
                    ...state,
                    [action.device_id]: {
                        ...state[action.device_id],
                        batches: [
                            {
                                id: state[action.device_id].batches[0].id - 1,
                                localizedEvents: [action.event],
                            },
                            ...state[action.device_id].batches,
                        ],
                    },
                };
            }
            return state;
        default:
            return state;
    }
}
